import { LoginField } from "..//components/LoginField";

export function PasswordFields(props: {
    password: string;
    confirmPassword: string;
    passwordErrorMessage: string;
    verifyPasswordErrorMessage: string;
    setPassword: (val: string) => void;
    setConfirmPassword: (val: string) => void;
}) {
    return (
        <>
            <LoginField
                fieldTitle="Password"
                fieldID="password"
                fieldType="password"
                value={props.password}
                onChange={(e) => props.setPassword(e.target.value)}
                invalidInput={props.passwordErrorMessage !== undefined}
                errorMessage={props.passwordErrorMessage} />
            <LoginField
                fieldTitle="Confirm Password"
                fieldID="confirmPassword"
                fieldType="password"
                value={props.confirmPassword}
                onChange={(e) => props.setConfirmPassword(e.target.value)}
                invalidInput={props.verifyPasswordErrorMessage !== undefined}
                errorMessage={props.verifyPasswordErrorMessage} />
        </>
    );
}
